import { createContext, useContext } from 'react';
import { EMPTY_PRODUCT_VALIDATIONS, ProductRuleFieldType, ProductValidations } from './type';

export { MISSING_FIELD_ERROR } from './type';

export const ProductValidationContext = createContext<ProductValidations>(EMPTY_PRODUCT_VALIDATIONS);

export const useProductValidations = () => useContext(ProductValidationContext);

/** Whether the field is required for activation; used for the asterisk on field labels. */
export const useIsFieldRequired = (field: ProductRuleFieldType) => !!useProductValidations().requiredFields[field];

/**
 * Error text for a missing required field. Only once the user has visited the field,
 * so a form is not red by default (same as the base required fields).
 */
export const useMissingFieldError = (field: string | undefined, touched: boolean) => {
  const { missingFields } = useProductValidations();
  if (!touched || !field) return undefined;
  return missingFields[field as ProductRuleFieldType];
};
